<template>
  <div>
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />
    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row v-for="item in 2" :key="item">
        <v-col cols="6">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>

    <div class="ma-4" v-show="!showSkeleton">
      <div class="text-h4">Atualizar Centro de Custo - {{ description }}</div>
    </div>
    <div v-if="canRender">
      <CadastroCentroDeCusto edicao="true" :_id="_id" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import centroDeCustoStore from '../_store'

import CadastroCentroDeCusto from './CadastroCentroDeCustos'

export default {
  name: 'AtualizarCentroDeCustos',
  props: {
    _id: String,
  },
  components: { CadastroCentroDeCusto, SkeletonLoaderTitleUpdate },

  data: () => ({
    description: '',
    codigo: '',
    showSkeleton: false,
    canRender: false,
  }),

  computed: {
    ...mapGetters('atualizarCentroDeCustoModulePABXStore', ['getCentroDeCustoSelecionado']),
  },

  async created() {
    this.showSkeleton = true
    registerVuexModule(this.$store, 'atualizarCentroDeCustoModulePABXStore', centroDeCustoStore)

    await this.listarCentroDeCustosSelecionado(this._id)

    this.description = this.getCentroDeCustoSelecionado.description
    this.codigo = this.getCentroDeCustoSelecionado.codigo

    this.showSkeleton = false
    this.canRender = true
  },

  methods: {
    ...mapActions('atualizarCentroDeCustoModulePABXStore', ['listarCentroDeCustosSelecionado']),
  },
}
</script>
